<template>
  <b-card class="mt-3">
    <b-row>
      <b-col cols="12" class="d-flex justify-content-between">
        <b-form-checkbox 
          v-model="status" 
          name="check-button" switch
        >
          <h5 v-if="status">
            <b-badge variant="success">Ativo</b-badge>
          </h5>
          <h5 v-else>
            <b-badge variant="danger">Inativo</b-badge>
          </h5>
        </b-form-checkbox>
        <span style="color: red;" class="fs-18"> {{ messageVideo }}</span>
      </b-col>
      <b-col cols="9" sm="10">
        <i :class="setIcon(typeLink)" class="mr-3 fs-30"></i>
        <span v-if="name" style="font-size: 24px;">{{ name }}</span>
        <span v-else style="font-size: 24px;">{{ setName(typeLink) }}</span>
      </b-col>
      <b-col cols="3" sm="2">
        <b-button
          class="ml-3 fs-18"
          size="sm"
          variant="outline-dark"
          v-b-toggle="`button=${typeLink}`"
          :disabled="!status"
        >
          <i class="fas fa-pencil-alt"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-collapse :id="`button=${typeLink}`" class="mt-2">
      <div class="mt-3">
        <b-form-group label="Descrição">
          <b-input
            :placeholder="name"
            v-model="name"
            :disabled="!status"
          ></b-input>
        </b-form-group>
      </div>
      <div class="mt-3">
        <b-form-group label="Link">
          <b-input
            :placeholder="url"
            v-model="url"
            :disabled="!status || typeLink == LINKTREE.ANDROID || typeLink == LINKTREE.IOS"
          ></b-input>
        </b-form-group>
      </div>
      <b-button class="mt-3" block variant="success" @click="save()">
        Salvar
      </b-button>
    </b-collapse>
  </b-card>
</template>

<script>
import LINKTREE from 'Enums/Linktree.js';
import { setIconsReport } from '@/utils/setIconsReport';
import { setNameReport } from '@/utils/setNameReport';

export default {
  name: 'LinkTreeComponent',
  emits: ['save'],
  props: {
    name: {
      type: String,
      required: true,
    },
    typeLink: {
      type: Number,
      required: true,
    },
    idType: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    status: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      LINKTREE,
      loading: false,
      messageVideo: "",
    };
  },
  watch: {
    'status': function () {
      this.save();
    },
  },
  methods: {
    save() {
      if(this.typeLink == LINKTREE.VIDEO && !this.url) {
        this.messageVideo = "Preencher os dados para salvar o video";
        return;
      }
      
      const data = {
        'name' : this.name,
        'url' : this.url,
        'order' : this.order,
        'status' : this.status,
        'id_type' : this.idType
      }

      this.$emit('save', data);
    },
    setName(type) {      
      return setNameReport(type);
    },
    setIcon(type) {
      return setIconsReport(type);
    }
  },
};
</script>
